<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M8.7 3.6 2.6 14.2c-.6 1 .1 2.3 1.3 2.3h12.2c1.2 0 1.9-1.3 1.3-2.3L11.3 3.6a1.5 1.5 0 0 0-2.6 0z"/><path d="M10 8v3.2M10 13.8h.01"/></svg>
</template>
